var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c__color-picker" },
    [
      _c(
        "el-popover",
        {
          attrs: {
            placement: "bottom",
            title: "",
            width: "314",
            "poper-class": "",
            trigger: "click",
          },
          on: { hide: _vm.whenHide },
          model: {
            value: _vm.visible,
            callback: function ($$v) {
              _vm.visible = $$v
            },
            expression: "visible",
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.visible,
                  expression: "visible",
                },
              ],
            },
            [
              _c("div", { staticClass: "gradient-div" }, [
                _c(
                  "div",
                  {
                    staticClass: "gradient-check",
                    class: _vm.activeIndex === 0 ? "active" : "",
                    on: {
                      click: function ($event) {
                        return _vm.checkGradient(0)
                      },
                    },
                  },
                  [_c("div", { style: { background: _vm.startColor } })]
                ),
                _c("span", {
                  staticClass: "gradient-div-span",
                  style: { background: _vm.gradientColor },
                }),
                _c(
                  "div",
                  {
                    staticClass: "gradient-check",
                    class: _vm.activeIndex === 1 ? "active" : "",
                    on: {
                      click: function ($event) {
                        return _vm.checkGradient(1)
                      },
                    },
                  },
                  [_c("div", { style: { background: _vm.endColor } })]
                ),
              ]),
              _c("div", { staticClass: "c__canvas" }, [
                _c("canvas", {
                  attrs: {
                    id: _vm.canvasId,
                    width: _vm.width,
                    height: _vm.height,
                  },
                  on: {
                    click: _vm.onCanvasClick,
                    mousedown: _vm.onCanvasMousedown,
                  },
                }),
                _c("em", {
                  staticClass: "c__cur",
                  attrs: { id: _vm.curId },
                  on: {
                    mousedown: function (e) {
                      _vm.onCanvasMousedown(e, "cur")
                    },
                  },
                }),
                _c("em", {
                  staticClass: "c__bar",
                  attrs: { id: _vm.barId },
                  on: {
                    mousedown: function (e) {
                      _vm.onCanvasMousedown(e, "bar")
                    },
                  },
                }),
                _vm.showAlpha
                  ? _c("div", { staticClass: "c__alpha-silder" }, [
                      _c("div", {
                        staticClass: "c__alpha-silder-bar",
                        style: _vm.alphaBarStyle,
                        on: {
                          click: _vm.onAlphaClick,
                          mousedown: _vm.onAlphaMousedown,
                        },
                      }),
                      _c("em", {
                        staticClass: "c__alpha",
                        style: { left: _vm.alpha * 100 + "%" },
                        attrs: { id: _vm.alphaId },
                        on: { mousedown: _vm.onAlphaMousedown },
                      }),
                    ])
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "c__control" }, [
                _c("input", {
                  staticClass: "c__input",
                  domProps: { value: _vm.innerValues[0] },
                }),
                _c("input", {
                  staticClass: "c__input",
                  domProps: { value: _vm.innerValues[1] },
                }),
                _c("div", { staticClass: "c__btns" }, [
                  _c(
                    "div",
                    {
                      staticClass: "c__btn-clear",
                      on: {
                        click: function ($event) {
                          _vm.curColor = ""
                        },
                      },
                    },
                    [_vm._v("清空")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "c__btn-confirm",
                      on: { click: _vm.confirm },
                    },
                    [_vm._v("确定")]
                  ),
                ]),
              ]),
            ]
          ),
          _c("div", {
            staticClass: "c__block",
            style: { background: _vm.formatBgColor(_vm.value) },
            attrs: { slot: "reference" },
            slot: "reference",
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }